import {all, fork ,call, put, takeEvery, takeLatest  } from 'redux-saga/effects'
import { push } from 'react-router-redux';
import NetworkHandler from '../net/NetworkHandler'
import StorageHandler from '../storage/StorageHandler';
import * as ACTIONS from '../containers/constants';
import { error ,success } from '../components/Alert/actions';
import {updateUserInformation ,updateInfodexGroups,getInfodexGroups as infodexGroups  ,updateCryodexGroups} from '../containers/Home/actions';
import {updateInfodexes} from '../containers/Infodex/actions';
const storageHandler = new StorageHandler();

function* getInfodexGroups(action){

  const Network = new NetworkHandler();
  
    try{

        const response = yield Network.requestInfodexGroupsGet();

        if (!(response instanceof Error)) {
						
			//setTimeout(function(){
				
			  localStorage.setItem('allInfodexGroups', JSON.stringify(response));
			  
			  
			//},1000); 

			yield put(
				updateInfodexGroups(
				  response
				)
			);			
			  
          } else {
            yield put(
              error({
                message: `Unable to get infodex groups. ${response}`,
              })
            );
        }
  
    }catch (errorMsg) {
        yield put(
            error({
             message: `Unable to load infodex groups, please try again.${errorMsg}`,
            })
        );
    }
}

function* createInfodexGroups(action){

  const Network = new NetworkHandler();
  
    try{
        let groups = {
                  Name: action.payload ,
                  Cryodex_ID: storageHandler.getID(),
                  Group_Type:ACTIONS.SPECIFIED_GROUP
        };

        const response = yield Network.requestInfodexGroupsCreate(groups);

        if (!(response instanceof Error)) {

            yield put(
              updateInfodexGroups(
                  response
                )
              );
          window.location.reload();
          } else {
            yield put(
              error({
                message: `Unable to create infodex groups. ${response}`,
              })
            );
          }
  
    }catch (errorMsg) {
        yield put(
            error({
             message: `Unable to create infodex groups, please try again.${errorMsg}`,
            })
        );
    }
}

function* mapInfodexRelationship(action){
  
  
  const Network = new NetworkHandler();
  
    try{
        var relationships = {
          Relationships : action.payload
        }

        const response = yield Network.requestMapInfodexRelationship(action.payload);
        
        if (!(response instanceof Error)) {
          yield put(
            updateInfodexGroups(
                response
              )
            );
			 window.location.reload();
          } else {
            yield put(
              error({
                message: `Unable to get all infodex. ${response}`,
              })
            );
        }
        
  
    }catch (errorMsg) {
      yield put(
          error({
            message: `Unable to load infodex groups, please try again.${errorMsg}`,
          })
      );
  }
}

function* deleteInfodexGroups(action){

  
  const Network = new NetworkHandler();
  
    try{
        const response = yield Network.requestDeleteInfodexGroup(action.payload);
        if (!(response instanceof Error)) {
          
          yield put(
            infodexGroups(
                response
              )
            );
			window.location.reload();
				
				//localStorage.setItem("tab",1);
				
          } else {
            yield put(
              error({
                message: `Unable to delete group member. ${response}`,
              })
            );
        }
    }catch (errorMsg) {
      yield put(
          error({
            message: `Unable to load infodex groups, please try again.${errorMsg}`,
          })
      );
  }
}

function* renameInfodexGroups(action){

  
  const Network = new NetworkHandler();
  
    try{

        const response = yield Network.requestRenameInfodexGroup(action.payload);
        if (!(response instanceof Error)) {
          
          yield put(
            infodexGroups(
                response
              )
            );
			 window.location.reload();
          } else {
            yield put(
              error({
                message: `Unable to delete group member. ${response}`,
              })
            );
        }
    }catch (errorMsg) {
      yield put(
          error({
            message: `Unable to load infodex groups, please try again.${errorMsg}`,
          })
      );
  }
}

function* deleteInfodexGroupMember(action){

  
  const Network = new NetworkHandler();
    try{
        const response = yield Network.requestDeleteInfodexGroupMember(action.payload);
        
        if (!(response instanceof Error)) {

          storageHandler.setInfoDeleted('Place deleted');
          yield put(
            updateInfodexGroups(
                response
              )
            );
             window.location.reload();
            
          } else {
            yield put(
              error({
                message: `Unable to delete group member. ${response}`,
              })
            );
        }
  
    }catch (errorMsg) {
      yield put(
          error({
            message: `Unable to load infodex groups, please try again.${errorMsg}`,
          })
      );
  }
}

export default function* usersSagas() {
  yield takeLatest(ACTIONS.CRYODEX_INFODEX_GROUPS_CREATE, createInfodexGroups);
  yield takeLatest(ACTIONS.CRYODEX_INFODEX_GROUPS_GET, getInfodexGroups);
  yield takeLatest(ACTIONS.CRYODEX_INFODEX_GROUPS_DELETE, deleteInfodexGroups);
  yield takeLatest(ACTIONS.CRYODEX_INFODEX_GROUPS_RENAME, renameInfodexGroups);
  yield takeLatest(ACTIONS.CRYODEX_INFODEX_GROUPS_MEMBER_DELETE, deleteInfodexGroupMember);
  yield takeLatest(ACTIONS.CRYODEX_USER_GROUPS_MAP_RELATIONSHIP ,mapInfodexRelationship);
}


